import { SOCKET_URL } from './../const'

export const setupSocket = port => dispatch => {
  dispatch(setupWebsocket(port))
}

const setupWebsocket = port => (dispatch, getState) => {

  console.log("Connecting to wetbsocket...", port)

  const ws = new WebSocket(SOCKET_URL)

  ws.onopen = evt => {
    console.log("[SOCKET] Connection successfull");
    ws.send(JSON.stringify({ id: port.toString(), origin: "scoreboard", action: "register" }));
  };

  ws.onclose = evt => {
    console.log("[SOCKET] Closed");
    setTimeout(() => dispatch(setupWebsocket(port)), 2000)
  };

  ws.onmessage = evt => {
    const d = JSON.parse(evt.data)
    console.log("[SOCKET] Got payload", d);
    if (d.action === "set") {
       _set(dispatch, JSON.parse(d.details))
       return
    }
    if (d.action === "reset") {
       _reset(dispatch)
       return
    }
    if (d.action === "pause") {
       _pause(dispatch)
       return
    }
    if (d.action === "resume") {
       _resume(dispatch)
       return
    }
    if (d.action === "start") {
       _start(dispatch)
       return
    }
    if (d.action === "update") {
       _update(dispatch, JSON.parse(d.details))
       return
    }
    if (d.action === "fouls") {
       _fouls(dispatch, JSON.parse(d.details))
       return
    }
    if (d.action === "bg") {
       _changeBG(dispatch, JSON.parse(d.details))
       return
    }
  };

  ws.onerror = evt => {
    console.log("[SOCKET] Error " + evt.data);
    ws.close();
    setTimeout(() => dispatch(setupWebsocket(port)), 2000)
  };
  
};

export const startTimer = () => dispatch => {
  dispatch({
    type: 'TIMER_START',
  })
}

export const tickTimer = () => dispatch => {
  dispatch({
    type: 'TIMER_TICK',
  })
}

const _changeBG = (dispatch, data) => {
  dispatch({
    type: 'CHANGE_BG',
    bg: data.bg,
  })
}

const _set = (dispatch, data) => {
  console.log('Match set, data=' + JSON.stringify(data))
  const match_id = data.match_id
  if (match_id) {
    console.log('Got match id')
  }
  dispatch({
    type: 'SETUP_MATCH',
    home: {
      name: data.home_team,
    },
    away: {
      name: data.away_team,
    },
    match_id,
  })
}

const _reset = dispatch => {
  console.log('Match reset')
  dispatch({
    type: 'RESET_MATCH',
  })
}

const _pause = dispatch => {
  console.log('Match pause')
  dispatch({
    type: 'PAUSE_MATCH',
  })
}

const _resume = dispatch => {
  console.log('Match resume')
  dispatch({
    type: 'RESUME_MATCH',
  })
}

const _start = dispatch => {
  console.log('Match start')
  dispatch({
    type: 'START_MATCH',
  })
}

const _update = (dispatch, data) => {
  console.log('Match update, data=' + JSON.stringify(data))
  dispatch({
    type: 'UPDATE_MATCH',
    home: {
      score: data.home_score,
    },
    away: {
      score: data.away_score,
    },
    timer: data.timer,
  })
}

const _fouls = (dispatch, data) => {
  console.log('Match fouls update, data=' + JSON.stringify(data))
  dispatch({
    type: 'UPDATE_FOULS',
    home: {
      fouls: data.home_fouls,
    },
    away: {
      fouls: data.away_fouls,
    },
  })
}
